import React from "react";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import ContactBanner from "../../components/pages/ContactUs/ContactBanner/ContactBanner";
import ExtraOrdinary from "../../components/pages/Services/ExtraOrdinary/ExtraOrdinary";
import ContactForm from "../../components/pages/ContactUs/ContactForm/ContactForm";
import { ContactPageProvider } from "../../context/ContactPageContext";

const ContactUs = () => {
  return (
    <ContactPageProvider>
      <div>
        <Navbar />
        <ContactBanner />
        <ContactForm />
        <ExtraOrdinary />
        <Footer />
      </div>
    </ContactPageProvider>
  );
};

export default ContactUs;
